module.exports = __webpack_public_path__ + "img/np.1cd1db3.svg";